import React from "react";
import { CpuIcon, CreditCardIcon, DownloadIcon, DropletsIcon, InfinityIcon, LayoutDashboardIcon, LockIcon, RecycleIcon, ShieldCheckIcon, SproutIcon, SunIcon, ZapIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { bonuses, images, volumes } from "../data/atlasContent";
const volumeIcons: Record<string, BoxIcon> = {
  'Balkon-Masterplan': LayoutDashboardIcon,
  'Hydroponik-Meisterschaft': DropletsIcon,
  'Licht-&-Energie-Meisterschaft': SunIcon,
  'Bokashi-&-Residuos-Meisterschaft': RecycleIcon,
  'Die-12-Gewinner-Sorten': SproutIcon,
  'Smart-Balcony-Automatisierung': CpuIcon
};
export function Solution() {
  return <section className="border-b border-line bg-panel py-20 lg:py-28 space-y-[19px]" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-111" data-mp="hwelifx2gjx3">
      <div className="mx-auto max-w-7xl px-6 space-y-[18px]" style={{
      borderTopWidth: "1px",
      borderRightWidth: "1px",
      borderBottomWidth: "1px",
      borderLeftWidth: "1px"
    }} data-id="element-112" data-mp="2c8336puon0l6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-16" data-id="element-113" data-mp="70qozorqyqf3">
          

          <div className="grid grid-cols-3 gap-3" data-id="element-114" data-mp="2y3vzkjcazgb">
            
            
            
          </div>
        </div>

        <div className="mt-20" style={{
        marginTop: "8px",
        marginBottom: "8px"
      }} data-id="element-115" data-mp="gq1yvdmgjz41">
          <h3 className="font-serif text-2xl font-semibold text-forest" data-id="element-116" data-mp="bsrzb55cu72h">
            Die 6 Bände des Systems{' '}
            <span className="font-sans text-base font-normal text-prose" data-id="element-117" data-mp="3k7k5xiuep23e">(650+ Seiten)</span>
          </h3>

          {/* BUNDLE-MOCKUP: direkt hier austauschbar (Bild anklicken und ersetzen oder die URL im src ändern). */}
          <div className="mt-8 w-full" data-id="element-118" data-mp="3u33pd5rsa8b9">
            <img src="https://cdn.magicpatterns.com/uploads/jiYPQQwLnSvUiu96TaKF6X/Comprimido.png" alt="3D-Mockup der Box Das Ultimative Urban Farming System 2026 mit den 6 Bänden im Fächer dahinter" className="mx-auto block h-auto w-full max-w-3xl" style={{
            filter: 'drop-shadow(0 24px 34px rgba(27, 48, 34, 0.18))'
          }} data-id="element-119" data-mp="3p63p5bhm7zs2" />
          </div>

          <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-120" data-mp="1ciwtq29iknt8">
            {volumes.map(volume => {
            const Icon = volumeIcons[volume.title];
            return <li key={volume.number} className="flex h-full flex-col rounded-xl border border-line bg-surface p-6 shadow-md shadow-forest/10" style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              borderColor: "#40916C"
            }} data-id="element-121" data-mp="1litngiargcv5">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-mint-soft" aria-hidden="true" data-id="element-122" data-mp="xro61yp69ciq">
                    <Icon className="h-5 w-5 text-emerald" data-id="element-123" data-mp="12pzhuez11x3l" />
                  </span>
                  <p className="mt-5 font-mono text-xs font-medium text-emerald" style={{
                marginTop: "0px",
                marginBottom: "0px"
              }} data-id="element-124" data-mp="17i0rdt4t99px">{volume.number}</p>
                  <p className="mt-1 font-serif text-lg font-semibold leading-snug text-forest" data-id="element-125" data-mp="f16jycyuhf6c">{volume.title}</p>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-prose" data-id="element-126" data-mp="7i71c9j7jro1">{volume.description}</p>
                  <p className="mt-auto pt-4 font-mono text-xs text-prose" style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }} data-id="element-127" data-mp="2ikoi17akdfr">{volume.pages}</p>
                </li>;
          })}
          </ul>
        </div>

        <div id="angebot" className="mt-16 mx-auto max-w-md scroll-mt-8 rounded-2xl bg-surface p-6 text-center shadow-xl shadow-forest/10 sm:p-8" style={{
        backgroundColor: "#E9FFEC",
        backgroundImage: "none",
        borderTopWidth: "1px",
        borderRightWidth: "0px",
        borderBottomWidth: "1px",
        borderLeftWidth: "0px",
        borderColor: "#007D00"
      }} data-id="element-128" data-mp="3opsnmlrmbo3c">
          {/* ANGEBOTS-BILD: direkt hier austauschbar (Bild anklicken und ersetzen oder die URL im src ändern). */}
          <div className="w-full" data-id="element-129" data-mp="310zoyhjm3251">
            <img src="https://cdn.magicpatterns.com/uploads/55ZGMGWMwz423fTPs5PLvn/ACTUALIZADA-COMPRIMIDA.jpg" alt="Der Diagnose-Atlas mit allen Bänden und Bonus-Tomos im Überblick" className="block h-auto w-full rounded-xl" style={{
            filter: 'drop-shadow(0 18px 26px rgba(27, 48, 34, 0.18))',
            height: "292px"
          }} data-id="element-130" data-mp="30z6j34gtoly3" />
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-prose" data-id="element-131" data-mp="3qqg5j73t9c68">
            <li className="flex items-center gap-1.5" data-id="element-132" data-mp="3gyk53pe959yu">
              <LockIcon className="h-3.5 w-3.5 text-emerald" aria-hidden="true" data-id="element-133" data-mp="3gwzf8d2vuf7b" />
              Sicherer Checkout
            </li>
            <li className="flex items-center gap-1.5" data-id="element-134" data-mp="37y47uxo3qz2f">
              <CreditCardIcon className="h-3.5 w-3.5 text-emerald" aria-hidden="true" data-id="element-135" data-mp="37zp2enaf2i0a" />
              Stripe-geprüft
            </li>
            <li className="flex items-center gap-1.5" data-id="element-136" data-mp="2u0pdrfmwm344">
              <ZapIcon className="h-3.5 w-3.5 text-emerald" aria-hidden="true" data-id="element-137" data-mp="2y0ps70a06eb6" />
              Sofortiger Zugang
            </li>
          </ul>

          <dl className="mt-6 flex items-end justify-center gap-4" data-id="element-138" data-mp="s554svs67mpc">
            <div data-id="element-139" data-mp="w81mmk9vzes8">
              <dt className="sr-only" data-id="element-140" data-mp="w6gxxba96q2a">Dein Preis heute</dt>
              <dd className="font-mono text-6xl font-semibold leading-none text-forest" data-id="element-141" data-mp="2grnemr3op2rw">€21</dd>
            </div>
            <div data-id="element-142" data-mp="2cqlg6chlcuqz">
              <dt className="sr-only" data-id="element-143" data-mp="2cmxmndc5c8c9">Gesamtwert</dt>
              <dd className="font-mono text-2xl text-prose line-through" data-id="element-144" data-mp="2qgoumha8bk5v">€189</dd>
            </div>
          </dl>

          <p className="mt-4 text-base font-semibold text-forest" data-id="element-145" data-mp="2lox4g7uzjgg9">
            6 Bände + 5 Bonus-Bände inklusive
            <span className="block font-normal text-prose" data-id="element-146" data-mp="30d1p3hdlm21o">(650+ Seiten · 87 % Ersparnis)</span>
          </p>

          <CtaButton label="JSICHEN SIE SICH DAS KOMPLETTE SYSTEM ( NUR 21 € )" className="mt-7 w-full" data-id="element-147" data-mp="2vf8gyisqixyr" />

          <ul className="mt-6 space-y-2 text-sm text-prose" data-id="element-148" data-mp="39d6ujlz8eqd7">
            <li className="flex items-center justify-center gap-2" data-id="element-149" data-mp="34h9dfdg59fzd">
              <InfinityIcon className="h-4 w-4 text-emerald" aria-hidden="true" data-id="element-150" data-mp="1f10cq4bu1bbx" />
              Einmalzahlung · Lebenslanger Zugang
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-151" data-mp="1a3qebz6gtpby">
              <ShieldCheckIcon className="h-4 w-4 text-emerald" aria-hidden="true" data-id="element-152" data-mp="3a57yksmhiocj" />
              100 % sichere Zahlung
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-153" data-mp="3f3rof4478ka6">
              <DownloadIcon className="h-4 w-4 text-emerald" aria-hidden="true" data-id="element-154" data-mp="3k1jdlqdglsao" />
              Sofortiger Download
            </li>
          </ul>

          <p className="mt-5 border-t border-line pt-5 text-xs leading-relaxed text-prose" data-id="element-155" data-mp="3o1v078pdu2os">
            Sofort-Zugang · 7 Tage Geld-zurück-Garantie · Bereits{' '}
            <span className="font-semibold text-forest" data-id="element-156" data-mp="1vojxesbcith">2.847 Urban Farmers</span> nutzen das System.
          </p>
        </div>

        <div className="mt-16" data-id="element-157" data-mp="6psro09ekuvm">
          <h3 className="font-serif text-xl font-semibold text-forest" data-id="element-158" data-mp="bnaura0qofvp">
            Plus: 5 Boni -{' '}
            <span className="font-sans text-base font-normal text-prose" data-id="element-159" data-mp="fowbj6ge9eb6">(Wert €93 – kostenlos für Frühadopter)</span>
          </h3>
          <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-4 lg:grid-cols-2" data-id="element-160" data-mp="ko0ma1iyvk3m">
            {bonuses.map(bonus => <li key={bonus.number} className="flex items-start gap-4 border-t border-line pt-4" style={{
            borderColor: "#035F16",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftWidth: "1px",
            paddingTop: "5px",
            paddingBottom: "5px"
          }} data-id="element-161" data-mp="2572zv1mbp1u0">
                <img src={bonus.cover} alt={`Cover: ${bonus.title}`} loading="lazy" className="h-14 w-14 shrink-0 rounded-md object-cover shadow-md shadow-forest/20" data-id="element-162" data-mp="1r6s9s0su7r9w" />
                <div className="min-w-0 flex-1" data-id="element-163" data-mp="2juefpfpjf7zx">
                  <p className="flex flex-wrap items-center gap-x-2 font-mono text-[11px] font-semibold tracking-wide text-emerald" style={{
                fontSize: "14px"
              }} data-id="element-164" data-mp="2juxvaprptkas">
                    <span data-id="element-165" data-mp="2a5ea3dgj5ecr">{bonus.number}</span>
                    <span aria-hidden="true" className="text-prose" data-id="element-166" data-mp="2a2ie3uo8szqy">·</span>
                    <span className="text-prose line-through" data-id="element-167" data-mp="37ks48w8wyopr">{bonus.value} Wert</span>
                    <span className="rounded bg-mint-soft px-1.5 py-0.5 text-emerald" style={{
                  fontSize: "12px"
                }} data-id="element-168" data-mp="32s8ru2lypzmj">KOSTENLOS</span>
                  </p>
                  <h4 className="mt-0.5 font-serif text-base font-semibold leading-snug text-forest" data-id="element-169" data-mp="2fw5nyraivx4s">{bonus.title}</h4>
                  <p className="mt-1 text-sm leading-snug text-prose" data-id="element-170" data-mp="218auh8ooxoqn">{bonus.description}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}